/**
 * Created by shbs on 08/06/2018.
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Locales from './locale';
import Element from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import Cookies from "js-cookie";
import {GetRequest} from "../utils"
Vue.use(VueI18n);
const messages = {};
messages.zh=Object.assign(zhLocale, Locales['zh']);
messages.en=Object.assign(enLocale, Locales['en']);


let locale = Cookies.get("language");

if(GetRequest()["language"]){
    locale= GetRequest()["language"];
    Cookies.set('language', locale);
}else {
    if(!locale){
        locale="en";
        Cookies.set('language', "en");
    }
}

const i18n = new VueI18n({
    locale: locale, // set locale
    messages, // set locale messages
});
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
});
// document.title=i18n.t("message.title");

export default i18n;



// WEBPACK FOOTER //
// ./src/locale/index.js